module.exports = __webpack_public_path__ + "static/media/pic3.9763e0d3.png";